<template lang="html">
  <v-container grid-list-md>
    <v-layout wrap>
      <v-flex v-bind="_pageLayout">
        <v-layout wrap>
          <v-flex
            xs12
            class="display-2 font-weight-light primary--text py-3"
          >
            Super Info Assist tracker
          </v-flex>
          <v-flex xs12>
            <v-divider />
          </v-flex>
          <v-flex
            xs12
            py-3
          >
            <div class="title font-weight-light">
              {{ request.title }}
            </div>
          </v-flex>
          <v-divider />
          <v-layout
            wrap
            align-center
          >
            <v-flex xs6>
              <v-flex xs12>
                <div class="caption">
                  Due Date
                </div>
                <div class="display-2">
                  {{ moment(request.assistanceDue).format('DD') }}
                </div>
                <div class="">
                  {{ moment(request.assistanceDue).format('MMM-YYYY') }}
                </div>
              </v-flex>
            </v-flex>
            <v-flex xs6>
              <v-flex xs12>
                <div class="caption">
                  Submission Date
                </div>
                <div class="">
                  {{ _formatDate(request.timestamp) }}
                </div>
              </v-flex>
              <v-flex xs12>
                <div class="caption">
                  Assistance Type
                </div>
                <div class="">
                  {{ request.assistanceText }}
                </div>
              </v-flex>
              <v-flex v-if="Object.keys(request.addons || {}).length > 0">
                <div class="caption">
                  Addons
                </div>
                <div
                  v-for="addon in request.addons"
                  :key="addon.id"
                >
                  {{ addon.name }}
                </div>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <v-divider />
          </v-flex>
          <v-flex xs12>
            <v-timeline dense>
              <v-slide-x-reverse-transition
                group
                hide-on-leave
              >
                <v-timeline-item
                  v-for="(item, i) in interactions"
                  :key="i"
                  small
                  fill-dot
                  :icon="item.icon"
                >
                  <v-layout align-center>
                    <v-flex xs12>
                      <div class="font-weight-bold">
                        {{ item.title }}
                      </div>
                      <!-- <div class="caption">{{_formatDate(item.timestamp)}}</div> -->
                      <div class="caption">
                        {{ item.description }}
                      </div>
                    </v-flex>
                    <v-flex
                      shrink
                      class="text-no-wrap caption"
                    >
                      {{ _formatDateTime(item.timestamp) }}
                    </v-flex>
                  </v-layout>
                </v-timeline-item>
              </v-slide-x-reverse-transition>
            </v-timeline>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import clientPath from '@/plugins/client-path'

// import messagintInit from '@/mixins/messaging-init'

export default {
  mixins: [ helpers ],
  data () {
    return {
      request: {},
      moment: moment
    }
  },
  computed: {
    ...mapGetters(['_pageLayout']),
    interactions () {
      return this._sortObject(this.request.interactions, (o) => Number(new Date(o.timestamp))).reverse()
    }
  },
  beforeMount () {
    // rtdb.ref(`assistance/requests/${this.$route.params.uid}/${this.$route.params.id}/public`).on('value', s => {
    rtdb.ref(`assistance/requests/${this.$route.params.id}/public`).on('value', s => {
      this.request = s.val() || {}
    })
  },
mounted () {
    clientPath.track(`view_assistance_tracker`, { requestId: this.$route.params.id })
  },
}
</script>

<style lang="css" scoped>

</style>
